module.exports = __webpack_public_path__ + "img/26b5dde.svg";